import styled from 'styled-components';
import theme from 'styles/theme';

export const MainWrapper = styled.div`
  padding-top: 27px;

  .contentsWrapper {
    padding: 0 30px 80px;

    .title {
      font-weight: 500;
      padding: 20px 0 5px;
      font-size: 16px;
      line-height: 24px;

      & > span {
        margin-top: 8px;
        display: inline-flex;
        align-items: flex-start;
        font-size: 14px;
        color: #78797c;
        line-height: 22px;
      }

      & > a {
        margin-left: 10px;
        font-size: 14px;
        color: ${theme.color.blue};
        text-decoration: underline;
      }
    }

    .accountFormStepBox {
      .stipulationSection {
        margin-top: 24px;
      }
    }

    .contactFormStepBox {
      & > div {
        display: flex;
        align-items: center;
        font-size: 14px;
      }
    }

    .QRFormStepRegisterBox {
      .imgBox {
        margin-top: 5px;
        text-align: center;

        img {
          width: 125px;
          padding: 2px;
          border: 1px solid;
        }
      }

      .uploadQRImg {
        margin: 18px 0 0;
        display: block;
        width: 100%;
        padding: 8px 16px;
        text-align: center;
        background: #f0f0ff;
        border-radius: 4px;
        border: 1px solid #d9d8ff;
        color: #4945ff;
        font-size: 12px;
        line-height: 16px;
        font-weight: 700;
        cursor: pointer;
      }

      .enterOtpNumber {
        margin: 50px 0 100px;

        label {
          padding-bottom: 10px;
          display: inline-flex;
          align-items: flex-start;
          font-size: 14px;
          color: #78797c;
          line-height: 18px;
        }

        input {
          display: block;
          padding: 0 16px;
          width: 100%;
          height: 40px;
          border: 1px solid #dcdce4;
          border-radius: 4px;

          &::-webkit-outer-spin-button,
          &::-webkit-inner-spin-button {
            -webkit-appearance: none;
          }
        }
      }
    }

    .QRFormStepPassBox {
      margin-top: 4px;

      p {
        font-size: 12px;
        line-height: 16px;
        color: #fc5555;

        button {
          margin-left: 3px;
          font-size: 12px;
          color: ${theme.color.buttonLink};
          font-weight: 700;
          text-decoration: underline;
        }
      }
    }

    .selectManagerStepBox {
      section {
        margin: 25px 0 30px;
        height: 300px;
        overflow-y: auto;
        scrollbar-width: none;
        -ms-overflow-style: none;

        .infoRow {
          height: 85px;
          border-bottom: 1px solid #d0d0d0;
          display: flex;
          flex-direction: column;
          justify-content: center;

          div {
            display: flex;
            align-items: center;
            justify-content: space-between;
          }

          p {
            margin-left: 30px;
            font-size: 12px;
            color: #777777;
          }
        }
      }

      .bottomNotice {
        font-size: 12px;
        line-height: 22px;
        color: #323232;
        margin-left: 10px;
      }

      span {
        font-size: 15px;
      }

      a {
        font-size: 12px;
        line-height: 22px;
        color: #02a4ff;
        text-decoration: underline;
        margin-left: 10px;
      }
    }

    .completeGuideStepBox {
      & > button {
        padding: 15px;
        width: 100%;
        border: 1px solid #dcdce4;
        text-align: center;
        font-size: 14px;
        color: #32324d;
        font-weight: 700;
        border-radius: 4px;
        margin-top: 20px;
      }
    }

    .nextBtnBox {
      margin-top: 50px;
    }
  }
`;

export const ContentBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 30%;
  height: 100px;
  background: ${theme.borderColor.contentBox};
  margin: 5px;
  border-radius: 5px;
  text-align: center;
`;

export const DataFnqWrap = styled.div`
  width: 100%;
  margin-top: 30px;
  padding: 20px 35px 40px 35px;
  background-color: #f7f7f7;
`;
